import React from 'react';
interface SupplierCardProps {
    className?: string;
    onClick?: () => void;
    title: string;
    img: string;
}

const SupplierCard = ({title, onClick, img, className}: SupplierCardProps) => {
    return (
        <div
            onClick={onClick}
            className={`w-[70px] h-[70px] p-5  bg-[var(--input-bg-color)] flex flex-col justify-center items-center rounded-xl ${
                className ?? ''
            }`}
        >
            <img
                src={img}
                alt={title}
                width={100}
                height={100}
                className="object-contain h-full w-full min-w-[100%] min-h-[100%]"
            />
            <h3 className="font text-[11px] whitespace-nowrap mt-[5px] text-[var(--primary-text-color)]">
                {title}
            </h3>
        </div>
    );
};

export default SupplierCard;
